import { useTranslation } from 'react-i18next';

import { Typography } from 'antd';
import cn from 'classnames';

import { useMobileMediaQuery } from '@/shared/lib/hooks';

import AIPatternIcon from '@/shared/assets/icons/ai-pattern-icon.svg';

import cls from './pattern-watchlist-title.module.css';

export function PatternWatchlistTitle({ onClick }: { onClick?: () => void }) {
    const { t } = useTranslation(['pattern-studio', 'table', 'pattern']);
    const isMobile = useMobileMediaQuery();

    return (
        <div className={cn(cls.container)}>
            <div className={cls.icon}>
                <AIPatternIcon
                    height={isMobile ? 24 : 34}
                    onClick={onClick}
                    width={isMobile ? 24 : 34}
                />
            </div>
            <div className={cls.title}>
                <Typography.Text>{t('myAiPattern')}</Typography.Text>
            </div>
        </div>
    );
}
